import React, {Component} from 'react';
import { RingLoader } from 'react-spinners';

import '../stylesheets/Loading.css'

class Loading extends Component {
  render() {
    return (
      <div className="loading" style={{  display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <RingLoader
          size={100}
          color="#45b97c"
          loading={this.props.loading}
        />
      </div>
    )
  }
}

export default Loading 